import React from "react";
import { SectionHeading } from "./SectionHeading";
import { valueBlocks } from "../data/landing";
const reassurances = ["No complicated teaching plans.", "No theology degree required.", "No rigid study schedule."];
export function ValueSection() {
  return <section className="bg-canvas" data-id="element-299" data-mp="mi10ww38qpcb">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-300" data-mp="ievzyxyt6vps">
        <SectionHeading eyebrow="A Complete Christian Faith Resource" title={<>
              Everything Your Family Needs to Start Exploring the{" "}
              <span className="text-royal" data-id="element-302" data-mp="8ni6p7xgas53">WHY Behind Faith.</span>
            </>} data-id="element-301" data-mp="igfh0qsahasm" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5" data-id="element-303" data-mp="3ox6h8i788gn">
          {valueBlocks.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(11,24,56,0.25)] md:p-7" data-id="element-304" data-mp="3utwx4lz9d37w">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-royal-light" data-id="element-305" data-mp="3lutbpbcmcbq8">
                <Icon className="h-7 w-7 text-royal" strokeWidth={2} aria-hidden="true" data-id="element-306" data-mp="1j9l8qrdnyaml" />
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold leading-tight text-ink" data-id="element-307" data-mp="1o1l8ojtqh3j6">{title}</h3>
              <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-308" data-mp="1aag5j7r5pt43">{text}</p>
            </li>)}
        </ul>

        <p className="mt-10 flex flex-col items-center justify-center gap-2 text-center font-display text-lg font-bold text-navy md:flex-row md:gap-4" data-id="element-309" data-mp="1eb9vs7s2nk05">
          {reassurances.map((line, i) => <React.Fragment key={line} data-id="element-310" data-mp="26ycsqvh3nmoa" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="hidden text-gold-deep md:inline" data-id="element-311" data-mp="26x1nssbx48vl">•</span>}
              <span data-id="element-312" data-mp="1t1z9phwx3d7p">{line}</span>
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}